/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

export const STATUS = ["IMPLANTED", "EXPLANTED"];
export const CycleFlag = { ACTIVE: "ACTIVE", INACTIVE: "INACTIVE" };
